import React from 'react'
import { Stack, Box, Card, Checkbox, Typography, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Chip } from 'src/Components'

const useStyles = makeStyles<{ isAlreadyConnected?: boolean }>()((theme, { isAlreadyConnected }) => ({
  manufacturerCard: {
    width: '100%',
    cursor: isAlreadyConnected ? 'not-allowed' : 'pointer',
    mb: 2,
    transition: 'border-color 0.2s',
    border: `1px solid transparent`,
    '&:hover': {
      border: isAlreadyConnected ? `1px solid transparent` : `1px solid ${theme.palette.primary.main}`,
    },
  },
}))

interface Props {
  vehicleName: string
  vin: string
  logoUrl: string | undefined
  // toggles a vehicle which can be connected afterwards
  toggleItem: () => void
  isSelected: boolean
  isAlreadyConnected?: boolean
}

/*
 * It is a vehicle list item shown in vehicle dialog list.
 */
const ConnectVehicleTile = ({ vehicleName, vin, logoUrl, toggleItem, isSelected, isAlreadyConnected }: Props): JSX.Element => {
  const { classes } = useStyles({ isAlreadyConnected })
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  const handleTileClick = (): void => {
    if (isAlreadyConnected) return

    toggleItem()
  }

  return (
    <Card className={classes.manufacturerCard} onClick={handleTileClick} sx={{ maxWidth: upMd ? 500 : '100%' }}>
      <Box sx={{ pt: 2, pl: 2, pr: 2 }} display="flex" alignItems="center">
        <Box component="img" src={logoUrl} height={theme.spacing(4)} alt="manufacturer-logo" />
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <Stack sx={{ ml: 2 }} gap={0.5}>
            <Typography variant="body1">{vehicleName}</Typography>
            <Typography variant="body2">{vin}</Typography>
          </Stack>
          {isAlreadyConnected ? (
            <Chip textKey="vehicle-integration.connected-vehicles.vehicle-already-connected" paletteColor={theme.palette.primary} isLoading={false} />
          ) : (
            <Checkbox checked={isSelected} />
          )}
        </Stack>
      </Box>
    </Card>
  )
}

export default ConnectVehicleTile
